import React, { Component, PropTypes } from 'react';
import LeftBarDetail from './left-bar-detail';

class RoomSize extends Component {

  render() {
    const { profileToShow, isEditable, editField } = this.props;
    return (
      <div>
        <LeftBarDetail
          isEditable={isEditable}
          itemName="Room Size"
          className="segment-content"
          infoToDisplay={profileToShow.roomSizeInfo.value}
          classification={profileToShow.roomSizeInfo.unit}
          editField={editField.bind(this, 'roomSizeInfo', {
            type: 'roomSizeInfo',
            isRequired: true,
            initialValue: {
              unit: profileToShow.roomSizeInfo.unit,
              value: profileToShow.roomSizeInfo.value,
            },
          })}
          inline
        />
      </div>
    );
  }
}

RoomSize.propTypes = {
  profileToShow: PropTypes.object,
  isEditable: PropTypes.bool,
  editField: PropTypes.func,
};

export default RoomSize;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-left-bar/room-size.jsx